import { PureComponent } from 'preact-compat'
import { CONTENT_TYPE_CONVERSATION, ContentType } from '@insided/shared/utils/contentType'
import Button from '@insided/control/uikit/Button'
import { promoteReply } from '../services/topicService'
import { ParentCategory } from '../interfaces'
import CategorySelector from '@insided/control/uikit/CategorySelector'

/* eslint-disable import/no-internal-modules */
import Modal, {
  ModalHeader,
  ModalBody,
  ModalFooter
} from '@insided/deprecated-preact-components/design-system-components/modal'
import InputUnit from '@insided/deprecated-preact-components/design-system-components/input-unit'
import TextField from '@insided/deprecated-preact-components/design-system-components/text-field'

export interface MoveToNewTopicModalProps {
  replyId: number
  contentType: ContentType
  categories: ParentCategory[]
  onClose: () => void
  onShowAlert: (type: 'success' | 'error', message?: string) => void
  getReplies: (page?: number, pageSize?: number, sort?: string) => Promise<any>
}

export interface MoveToNewTopicModalState {
  title: string
  categoryId: number | null
  isLoading: boolean
}

function getSuccessMessage(privateId: number, title: string) {
  const topicUrl = `${window.location.origin}/${CONTENT_TYPE_CONVERSATION}s/${privateId}`
  const topicLink = `<a href="${topicUrl}">${title}</a>`
  return `The reply has been successfully moved to ${topicLink}`
}

class MoveToNewTopicModal extends PureComponent<MoveToNewTopicModalProps, MoveToNewTopicModalState> {
  constructor(props: MoveToNewTopicModalProps) {
    super(props)
    this.state = {
      title: '',
      categoryId: null,
      isLoading: false
    }
    this.onChangeTitle = this.onChangeTitle.bind(this)
    this.onChangeCategory = this.onChangeCategory.bind(this)
    this.onMoveToNewTopic = this.onMoveToNewTopic.bind(this)
  }

  onChangeTitle(title: string) {
    this.setState({ title })
  }

  onChangeCategory(categoryId: number) {
    this.setState({ categoryId })
  }

  async onMoveToNewTopic() {
    const { contentType, replyId, onShowAlert, onClose, getReplies } = this.props
    const { title, categoryId } = this.state

    this.setState({ isLoading: true })

    try {
      const privateId = await promoteReply(contentType, replyId, title, categoryId as number)
      onClose()
      onShowAlert('success', getSuccessMessage(privateId, title))
      setTimeout(async () => {
        await getReplies()
      }, 500)
    } catch {
      onShowAlert('error')
    }

    this.setState({ isLoading: false })
  }

  render() {
    const { categories, onClose } = this.props
    const { isLoading, title, categoryId } = this.state
    const disableMoveButton = title.length < 3 || categoryId === null

    return (
      <Modal onClose={onClose} isControl>
        <ModalHeader title='Move to new topic' />
        <ModalBody>
          <InputUnit label='Create a new topic for this post' isControl>
            <TextField
              id='move-to-new-topic'
              ariaLabel='move-to-new-topic'
              name='move-to-new-topic'
              onKeyUp={this.onChangeTitle}
              isControl
              type='text'
            />
          </InputUnit>
          <InputUnit>
            <CategorySelector categories={categories} categoryId={categoryId} onUpdate={this.onChangeCategory} />
          </InputUnit>
        </ModalBody>
        <ModalFooter>
          <Button
            title='Move to new topic'
            variant='primary'
            onClick={this.onMoveToNewTopic}
            isLoading={isLoading}
            disabled={disableMoveButton}
            size='medium'
            data-qa='move-to-new-topic'
          />
        </ModalFooter>
      </Modal>
    )
  }
}

export default MoveToNewTopicModal
